import React from "react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import App from "../App";
import { Provider } from "react-redux";
import { store, persister } from "./store/";
import { PersistGate } from "redux-persist/integration/react";
// you will also need the css that comes with bootstrap-daterangepicker
import "bootstrap-daterangepicker/daterangepicker.css";
import NotificationContextProvider from "./context/NotificationsContext";

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persister}>
    <NotificationContextProvider>
      <App></App>
      </NotificationContextProvider>
    </PersistGate>
  </Provider>
);
